import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SearchProduct.css";
import { Input, Space, Button } from "antd";
import { toast } from "react-hot-toast";

const { Search } = Input;

const SearchProduct = () => {
  const [domain, setDomain] = useState("");
  const [domainValue, setDomainValue] = useState("");

  const calculateDomainValue = (value) => {
    if (value.trim() === "") {
      toast.error("Please enter a domain name to appraise its value!");
      return;
    }

    // Extract only the middle part of the domain name, omitting www, https, and specific extensions
    const cleanedDomain = value.replace(
      /(https?:\/\/)?(?:www\.)?([^/\s]+)\.([^/\s]+\..*|com|gold|in|net|org|tech|gift).*$/i,
      "$2"
    );

    // Calculate domain value based on the length
    const domainLength = cleanedDomain.length;
    let calculatedValue = "";

    if (domainLength === 1) {
      calculatedValue = "2,99,49,325";
    } else if (domainLength > 1 && domainLength <= 3) {
      calculatedValue = "1,19,459";
    } else if (domainLength > 3 && domainLength <= 5) {
      calculatedValue = "14,356";
    } else if (domainLength > 5 && domainLength <= 8) {
      calculatedValue = "8,549";
    } else {
      calculatedValue = "999";
    }

    setDomainValue(calculatedValue);
  };

  const handleInputChange = (e) => {
    setDomain(e.target.value);
    if (e.target.value === "") {
      setDomainValue("");
    }
  };

  return (
    <div className="productSearchbar">
      <Space direction="vertical" style={{ width: "100%" }}>
        <Search
          addonBefore="https://"
          placeholder="Enter your domain name"
          allowClear
          onSearch={calculateDomainValue}
          onChange={handleInputChange}
          value={domain}
          size="large"
          // enterButton="Submit"
          enterButton={
            <Button
              type="primary"
              style={{
                background:
                  "linear-gradient(to right, #bc833bdb, #fcdb6a, #e3b757)",
                borderColor: "#1b4965",
                color: "black",
                padding: "15px",
              }}
            >
              Submit
            </Button>
          }
        />
      </Space>

      {domainValue && (
        <p className="domainValue paragraph text-center mt-[20px]">
          Your Approximate Domain Value is :{" "}
          <span className="text-main text-[28px] font-bold">
            Rs.{domainValue}
          </span>
          <br />
          Please{" "}
          <Link to="/marketplace-help" className="text-main">
            <span className="text-pent">contact us</span>
          </Link>{" "}
          for a detailed analysis of your domain name.
        </p>
      )}
    </div>
  );
};

export default SearchProduct;
